(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = `${window.Shopify.routes.root}cart`;
    } else {
      setTimeout(() => {
        const cartButton = document.querySelector('[data-cart-mini-toggle]');
        if (cartButton) {
          cartButton.click();
        }
      }, 1000);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
